export const levels = [
  {
    id: "bronze",
    label: "Bronze",
    nameKey: "levels.bronze.label",
    toolsLabelKey: "levels.bronze.toolsLabel",
    descriptionKey: "levels.bronze.description",
    workspaceKey: "levels.bronze.workspace",
    toolsLabel: "Bronze tools",
    description: "Core vocabulary, pronunciation, and writing practice for early Dictogloss in Action learners.",
    color: "#b7794d",
    accent: "#8a4f2e",
    background: "#f7efe7",
    badge: "/common/module-assets/bronze/bronze_badge.webp",
    header: "/common/module-assets/bronze/bronze_header.webp",
    cards: {
      vocabulary: "/common/module-assets/bronze/bronze_card_vocabulary.webp",
      pronunciation: "/common/module-assets/bronze/bronze_card_pronunciation.webp",
      writing: "/common/module-assets/bronze/bronze_card_writing.webp"
    },
    modules: 6,
    lessonsPerModule: 5,
    tools: ["vocabulary", "pronunciation", "writing"]
  },
  {
    id: "silver",
    label: "Silver",
    nameKey: "levels.silver.label",
    toolsLabelKey: "levels.silver.toolsLabel",
    descriptionKey: "levels.silver.description",
    workspaceKey: "levels.silver.workspace",
    toolsLabel: "Silver tools",
    description: "Vocabulary, pronunciation, writing, and summarizing practice for intermediate learners.",
    color: "#94a3b8",
    accent: "#475569",
    background: "#eef2f6",
    badge: "/common/module-assets/silver/silver_badge.webp",
    header: "/common/module-assets/silver/silver_header.webp",
    cards: {
      vocabulary: "/common/module-assets/silver/silver_card_vocabulary.webp",
      pronunciation: "/common/module-assets/silver/silver_card_pronunciation.webp",
      writing: "/common/module-assets/silver/silver_card_writing.webp",
      summarizing: "/common/module-assets/silver/silver_card_summarizing.webp"
    },
    modules: 6,
    lessonsPerModule: 5,
    tools: ["vocabulary", "pronunciation", "writing", "summarizing"]
  },
  {
    id: "gold",
    label: "Gold",
    nameKey: "levels.gold.label",
    toolsLabelKey: "levels.gold.toolsLabel",
    descriptionKey: "levels.gold.description",
    workspaceKey: "levels.gold.workspace",
    toolsLabel: "Gold tools",
    description: "Advanced practice for stronger vocabulary, pronunciation, writing, and summarizing.",
    color: "#c6a75a",
    accent: "#7c5d12",
    background: "#f8f1dc",
    badge: "/common/module-assets/gold/gold_badge.webp",
    header: "/common/module-assets/gold/gold_header.webp",
    cards: {
      vocabulary: "/common/module-assets/gold/gold_card_vocabulary.webp",
      pronunciation: "/common/module-assets/gold/gold_card_pronunciation.webp",
      writing: "/common/module-assets/gold/gold_card_writing.webp",
      summarizing: "/common/module-assets/gold/gold_card_summarizing.webp"
    },
    modules: 6,
    lessonsPerModule: 5,
    tools: ["vocabulary", "pronunciation", "writing", "summarizing"]
  }
];

export const tools = {
  vocabulary: {
    id: "vocabulary",
    labelKey: "tools.vocabulary.label",
    titleKey: "tools.vocabulary.title",
    subtitleKey: "tools.vocabulary.subtitle",
    launcherTextKey: "tools.vocabulary.launcherText",
    launcherPointsKey: "tools.vocabulary.launcherPoints",
    label: "Vocabulary",
    title: "Vocabulary Practice",
    subtitle: "Choose your book location and practice vocabulary with feedback.",
    launcherText: "Study words, chunks, meanings, and example sentences.",
    launcherPoints: ["Mixed quiz", "Writing", "Speaking/listening", "Vocab Burst"],
    accent: "#059669",
    accentStrong: "#047857",
    soft: "#d1fae5",
    surface: "#ecfdf5",
    ring: "rgba(5, 150, 105, .24)"
  },
  pronunciation: {
    id: "pronunciation",
    labelKey: "tools.pronunciation.label",
    titleKey: "tools.pronunciation.title",
    subtitleKey: "tools.pronunciation.subtitle",
    launcherTextKey: "tools.pronunciation.launcherText",
    launcherPointsKey: "tools.pronunciation.launcherPoints",
    label: "Pronunciation",
    title: "Pronunciation Practice",
    subtitle: "Listen, repeat, and compare your pronunciation.",
    launcherText: "Listen, repeat, and check your spoken line.",
    launcherPoints: ["Computer voice", "Premium Voice", "Speech scoring"],
    accent: "#7c3aed",
    accentStrong: "#5b21b6",
    soft: "#ede9fe",
    surface: "#f5f3ff",
    ring: "rgba(124, 58, 237, .24)"
  },
  writing: {
    id: "writing",
    labelKey: "tools.writing.label",
    titleKey: "tools.writing.title",
    subtitleKey: "tools.writing.subtitle",
    launcherTextKey: "tools.writing.launcherText",
    launcherPointsKey: "tools.writing.launcherPoints",
    label: "Writing",
    title: "Writing Practice",
    subtitle: "Choose your module, write in the workspace, and check goals as you revise.",
    launcherText: "Draft a response and track live writing goals.",
    launcherPoints: ["Word count", "Sentence length", "Vocabulary goals"],
    accent: "#e11d48",
    accentStrong: "#be123c",
    soft: "#ffe4e6",
    surface: "#fff1f2",
    ring: "rgba(225, 29, 72, .24)"
  },
  summarizing: {
    id: "summarizing",
    labelKey: "tools.summarizing.label",
    titleKey: "tools.summarizing.title",
    subtitleKey: "tools.summarizing.subtitle",
    launcherTextKey: "tools.summarizing.launcherText",
    launcherPointsKey: "tools.summarizing.launcherPoints",
    label: "Summarizing",
    title: "Summarizing Practice",
    subtitle: "Choose a passage, write a summary, and check length and copying limits.",
    launcherText: "Read a passage and write a focused summary.",
    launcherPoints: ["Source text", "Word range", "Quality checks"],
    accent: "#f97316",
    accentStrong: "#c2410c",
    soft: "#ffedd5",
    surface: "#fff7ed",
    ring: "rgba(249, 115, 22, .24)"
  }
};

export const writingGoals = {
  bronze: {
    wordLimits: [75, 85, 95, 105, 115, 125],
    unitWordLimits: [3, 3, 3, 3, 3, 3],
    meanLengthLimits: [6.5, 7, 7.5, 8, 8.5, 9]
  },
  silver: {
    wordLimits: [100, 110, 120, 130, 140, 150],
    unitWordLimits: [3, 3, 3, 4, 4, 4],
    meanLengthLimits: [8, 8.5, 9, 9.5, 10, 10.5],
    cttrLimits: [3, 3.2, 3.4, 3.6, 3.8, 4]
  },
  gold: {
    unitWordLimits: [4, 4, 4, 5, 5, 5],
    meanLengthLimits: [10, 10.5, 11, 11.5, 12, 12.5],
    cttrLimits: [3.6, 3.8, 4, 4.2, 4.4, 4.6]
  }
};

export function getLevel(levelId) {
  return levels.find((level) => level.id === levelId) || levels[0];
}

export function isToolAvailable(level, toolId) {
  return level.tools.includes(toolId);
}
